import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {SettingService} from 'app/components/setting/setting.service';
declare var jQuery: any;
import {SharedServiceService} from 'app/services/shared-service.service';
import {BaseInfoService} from 'app/services/base-info.service';

@Component({
  selector: 'app-saved-bill',
  templateUrl: './saved-bill.component.html',
  styleUrls: ['./saved-bill.component.scss']
})
export class SavedBillComponent implements OnInit {
  @Input() selectedBill;
  savedBillList;
  companyBillList = [];
  billEntity = {
    billId: '',
    billType: '',
    creationDate: 0,
    title: '',
    userBillUniqueId: ''
  };
  @Input() isEmpty = false;
  @Input() isInvalid = false;
  @Input() hasInquiry = false;
  @Input() billType = '';
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  billTypeList = [
    {
      code: 1,
      billType : 'Water',
      billTypeNameFa: 'آب'
    },
    {
      code: 2,
      billType : 'Electricity',
      billTypeNameFa: 'برق'
    },
    {
      code: 3,
      billType : 'Gas',
      billTypeNameFa: 'گاز'
    },
    {
      code: 4,
      billType : 'Telephone',
      billTypeNameFa: 'تلفن ثابت'
    },
    {
      code: 5,
      billType : 'Mobile',
      billTypeNameFa: 'تلفن همراه'
    },
    {
      code: 6,
      billType : 'Municipality',
      billTypeNameFa: 'عوارض شهرداری'
    },
    {
      code: 7,
      billType : 'Unknown',
      billTypeNameFa: ''
    },
    {
      code: 8,
      billType : 'Tax',
      billTypeNameFa: 'سازمان مالیات'
    },
    {
      code: 9,
      billType : 'TrafficPenalties',
      billTypeNameFa: 'جرایم رانندگی'
    },
    {
      code: 0,
      billType : 'Unknown',
      billTypeNameFa: ''
    },
  ];
  constructor(private settingServ: SettingService, private baseInfo: BaseInfoService,
              private sharedService: SharedServiceService ) { }

  ngOnInit(): void {
    this.getCompaniesBills();
    this.getBillList();
  }
  getBillList() {
    this.savedBillList = JSON.parse(sessionStorage.getItem('savedBills'));
    if (!this.savedBillList) {
      this.savedBillList = [];
      this.settingServ.getsavedBills().subscribe(
        res => {
          if (res.code === 0) {
            this.savedBillList = res.content.userBills;
            this.savedBillList.forEach(element => {
              if (element.title === null) {
                element.title = this.billTypeList.find(el => el.billType === element.billType).billTypeNameFa;
                if (element.billType === 'Unknown') {
                  const temp = this.getOtherBill(element.billId);
                  if (temp !== undefined ) {
                    element.title = temp.companyName;
                  }
                }
              }
            });
            sessionStorage.setItem('savedBills', JSON.stringify(res.content.userBills));
            this.filterBills();
          }
        }
      );
    } else {
      this.filterBills();
    }
  }
  getCompaniesBills() {
    this.companyBillList = JSON.parse(sessionStorage.getItem('companyBillList'));
    if (!this.companyBillList) {
      this.companyBillList = [];
      this.baseInfo.getCompaniesBills().subscribe(
        res => {
          if (res.code === 0) {
            this.companyBillList = res.content.billCompanies;
            sessionStorage.setItem('companyBillList', JSON.stringify(res.content.billCompanies));
          }
        }
      );
    }
  }
  getOtherBill(billId) {
    let code = billId[billId.length - 5];
    code += billId[billId.length - 4];
    code += billId[billId.length - 3];
    return this.companyBillList.find(el => el.code === code);
  }
  sendBill() {
    if (this.selectedBill === undefined || this.selectedBill.length === 0) {
      this.isEmpty = true;
    } else {
      this.isEmpty = false;
      this.selectedBill = this.sharedService.convertToEnglishNumber(this.selectedBill);
      if (this.selectedBill !== this.billEntity.billId) {
        const code = Number(this.selectedBill[this.selectedBill.length - 2 ]);
        const temp = this.billTypeList.find(el => el.code === code);
        this.billEntity.billId = this.selectedBill;
        this.billEntity.billType = temp.billType;
        this.billEntity.title = temp.billTypeNameFa;
        if (code === 0) {
          const otherBill = this.getOtherBill(this.selectedBill);
          if (otherBill !== undefined ) {
            this.billEntity.title = otherBill.companyName;
          }
        }
      }
      this.notifyParent.emit(this.billEntity);
    }
  }
  sendParentNotification(index) {
    jQuery('#bills').modal('hide');
    this.isEmpty = false;
    this.selectedBill = this.savedBillList[index].billId;
    const selectedBillObj = { ...this.savedBillList[index]};
    this.notifyParent.emit(selectedBillObj);
  }
  filterBills() {
    if (this.hasInquiry) {
      this.savedBillList = this.savedBillList.filter(x => x.billType === this.billType);
    }
  }
}
